import Axios from 'axios';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import React, { useEffect, useState } from 'react';
import BlockUi from 'react-block-ui';
import { Loader } from 'react-loaders';
import { PaymentInputsWrapper, usePaymentInputs } from 'react-payment-inputs';
import images from 'react-payment-inputs/images';
import { NavLink } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Card, CardBody, Col, Input, Modal, ModalBody } from 'reactstrap';
import styled from "styled-components";
import swal from 'sweetalert';
import courseIcon from '../../assets/icon-primeira-fase.png';
import { AuthContext } from '../../contexts/AuthContext';
import decimal from '../../helpers/decimal';
import CourseStatusEnum from '../../helpers/enums/courseStatus';
import paymentTypeEnum from '../../helpers/enums/paymentType';
import refreshToken from "../../helpers/tokenHelper";
import utils from '../../helpers/utils';
import api from '../../services/api';

dayjs.extend(utc);

const CourseCardContainer = styled(Card)`
border-radius: 15px;
`
const CardBodyClass = styled.div`
display: flex;
flex-direction: column;
align-items: center;
color: #73777f;
font-weight: 600;
min-height: 250px;
`;

const StyledButton = styled.button`
  color: #fff;
  background-color:  rgba(35, 157, 219, 1);
  border: unset;
  border-radius: 20px;
  padding: 10px;  
  text-decoration: none;
  text-transform: uppercase;
  font-weight: bold;
  width: 180px;
  margin-top: auto;
  &:hover {
    text-decoration: none;
    color: #ddd;
    background-color: rgba(41, 107, 169, 1); 
  }
  &:active {
    font-weight: bold;
  }
`;

const StyledButtonLink = styled(NavLink)`
  color: #fff;
  background-color:  rgba(35, 157, 219, 1);
  border-radius: 20px;
  padding: 10px;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: bold;
  width: 180px;
  margin-top: auto;
  &:hover {
    text-decoration: none;
    color: #ddd;
    background-color: rgba(41, 107, 169, 1); 
  }
  &:active {
    font-weight: bold;
  }
`;

const StyledButtonDisabled = styled.span`
  cursor: not-allowed;
  color: #000;
  background-color:  rgba(133, 133, 133, 1);
  border-radius: 20px;
  padding: 10px;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: bold;
  width: 180px;
  margin-top: auto;
  &:hover {
    text-decoration: none;
    color: #000;
    background-color: rgba(200, 200, 200, 1); 
  }
  &:active {
    font-weight: bold;
  }`

const CardTitle = styled.h5`
  font-weight: bold;
  text-transform: uppercase;
  color: rgb(57, 118, 170);
  font-size: 25px;
`

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const CreditCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 5px;
`

const CreditCardContainerTop = styled.div`
  display: flex;
  flex-direction: row;
  margin: 5px;
  align-items: center;
`

const ErrorSpan = styled.span`
    color: #c9444d;
    font-size: 0.75rem;
    margin-top: 0.25rem;
`

const CreditCardContainerLabel = styled.h5`
  font-weight: bold;
  text-transform: uppercase;
  font-size: 16px;
`

const StyledFormButton = styled.button`
  color: #fff;
  background-color:  rgba(35, 157, 219, 1);
  border: unset;
  border-radius: 20px;
  padding: 10px;  
  text-decoration: none;
  text-transform: uppercase;
  font-weight: bold;
  width: 100%;
  font-size: 12px;
  margin-top: 20px;
  &:hover {
    text-decoration: none;
    color: #ddd;
    background-color: rgba(41, 107, 169, 1); 
  }
  &:active {
    font-weight: bold;
  }
`;

const StyledModalBody = styled(ModalBody)`
  @media (max-width: 768px) {
    padding: 35px 5px;
  }
`;

function CourseCard(props) {
  const { dispatch, auth } = React.useContext(AuthContext);
  const [modalVisibility, setModalVisibility] = useState(false);
  const [name, setName] = useState("");
  const [document, setDocument] = useState("");
  const [type, setType] = useState("CC");
  const [address, setAddress] = useState({
    street: '',
    number: '',
    city: '',
    estate: '',
    cep: '',
    complement: ''
  })
  const [cardNumber, setCardNumber] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [cvc, setCVC] = useState("");
  const [courseId, setCourseId] = useState("")
  const [errors, setErrors] = useState({})
  const [loading, setLoading] = useState(false)
  const [installments, setInstallments] = useState(1)
  const [promotionCode, setPromotionCode] = useState("")
  const [priceWithInstallments, setPriceWithInstallments] = useState([])
  const [priceWithInstallmentsDefault, setPriceWithInstallmentsDefault] = useState([])

  const handleInstallmentsLength = id => {
    if(id === '6707e626fd296106f1170ce0') return [1, 2, 3 ,4];
    return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
    // if(id === '62c2f90f5bc4416696d1444d' || id === '63348022849af5728c2839a0') return [1, 2, 3, 4]
    // else return [1, 3, 6, 9, 12]
  }

  const settedInstallments = handleInstallmentsLength(props.course._id)

  useEffect(() => {
    dispatch("BLOCK_UNBLOCK_UI")
    setTimeout(() => {
      let newPriceWithInstallments = []
      for (let index = 0; index < settedInstallments.length; index++) {
        let price = decimal.div(props.course.price, settedInstallments[index])
        newPriceWithInstallments.push(price)
      }
      setPriceWithInstallments(newPriceWithInstallments)
      setPriceWithInstallmentsDefault(newPriceWithInstallments)
      dispatch("BLOCK_UNBLOCK_UI")
    }, 1000)
  }, [props.course])


  useEffect(() => {
    if (promotionCode === REACT_APP_PROMOTIONCODE) {
      let newPriceWithInstallments = []
      for (let index = 0; index < settedInstallments.length; index++) {
        let coursePrice = decimal.sub(props.course.price, decimal.div(decimal.mul(props.course.price, REACT_APP_PROMOTIONDISCOUNT), 100))
        let price = decimal.div(coursePrice, settedInstallments[index])
        newPriceWithInstallments.push(price)
      }
      setPriceWithInstallments(newPriceWithInstallments)
    } else {
      setPriceWithInstallments(priceWithInstallmentsDefault)
    }
  }, [promotionCode])

  const toggleLoading = (state) => {
    setLoading(state)
  }
  const toggleModal = (id) => {
    setModalVisibility(!modalVisibility);
    setCourseId(id)
    setAddress({
      street: '',
      number: '',
      city: '',
      estate: '',
      cep: '',
      complement: ''
    })
    setName("")
    setType("CC")
    setDocument("")
    setCardNumber("");
    setExpiryDate("");
    setCVC("");
    setPromotionCode("")
  }

  const payCourse = () => {
    let isValid = true;
    let error = {}

    if (!name) {
      error.name = "O campo nome é obrigatório"
      isValid = false;
    } else if (name.length > 70) {
      error.name = "O campo nome possui mais que 70 caractéres"
      isValid = false;
    }
    if (!document) {
      error.document = "O campo documento é obrigatório"
      isValid = false
    }
    if (!type) {
      toast.error('Selecione um método de pagamento')
      isValid = false
    }
    if (type === "invoice") {
      meta.error = undefined;
      if (!address.cep) {
        error.cep = "O campo CEP é obrigatório"
        isValid = false;
      }
      if (!address.number) {
        error.number = "O campo número é obrigatório"
        isValid = false;
      }
    } else if (type === "CC") {
      if (!cardNumber) {
        toast.error('Informe o número do cartão')
        isValid = false
      }
    }
    setErrors(error)
    if (isValid && !meta.error) {
      const hasPromotion = promotionCode === REACT_APP_PROMOTIONCODE
      let priceCourse = props.course.price
      if (hasPromotion) priceCourse = decimal.sub(props.course.price, decimal.div(decimal.mul(props.course.price, REACT_APP_PROMOTIONDISCOUNT), 100))
      priceCourse = decimal.div(priceCourse, installments)
      swal({
        title: "Compra de curso",
        text: `Você confirma a compra de ${props.course.name} no valor de ${utils.formatBRL(priceCourse)} em ${installments}x`,
        icon: "warning",
        buttons: {
          cancel: "Voltar",
          confirm: "Sim"
        },
        dangerMode: true,
      })
        .then((willBuy) => {
          if (willBuy) {
            toggleLoading(true)

            let payload = {
              userId: auth.user._id,
              courseId: courseId,
              promotionCode: !promotionCode ? undefined : promotionCode,
              type: "",
              customer: {
                name,
                document
              }
            }

            if (type === "CC") {
              payload.type = paymentTypeEnum.CREDIT_CARD
              payload.installments = installments
              payload.payment = {
                amount: props.course.price,
                softDescriptor: `GrupoMPT`,
                installments
              }
              payload.creditCard = {
                number: cardNumber.replaceAll(" ", ""),
                holder: name,
                expirationDate: expiryDate.replaceAll(" ", "").replace("/", "/20"),
                securityCode: cvc,
                brand: meta.cardType.type === "mastercard" ? "Master" : meta.cardType.type
              }
              const link = "/course/CCenrollStudent"
              api.put(link, payload).then(res => {
                toast.success('Inscrição realizada com sucesso.')
                toggleLoading(false);
                toggleModal();
                refreshToken(dispatch);
                props.refresher();
              }).catch(error => {
                toggleLoading(false);
                if (error.response.data.message == 'Not Authorized') {toast.error('Transação não autorizada.')}
                else if (error.response.data.message == 'Blocked Card') {toast.error('Cartão de crédito bloqueado.')}
                else if (error.response.data.message == 'Timeout ') {toast.error('Limite de tempo de transação excedido.')}
                else if (error.response.data.message == 'Problems with Creditcard') {toast.error('Há um problema com o cartão de crédito.')}
                else if (error.response.data.message == 'Card Canceled') {toast.error('Cartão de crédito cancelado.')}
                else if (error.response.data.message == 'Card Expired') {toast.error('Cartão de crédito expirado.')}
                else {toast.error('Ops, algo deu errado!')}
              })
            } else { // Boleto
              payload.customer.address = address,
              payload.customer.identity = payload.customer.document
              payload.type = paymentTypeEnum.BILLET
              payload.payment = {
                type: 'Boleto',
                amount: props.course.price,
                provider: "Bradesco",
                boletoNumber: generateBilletNumber(),
                assignor: process.env.REACT_APP_ASSIGNOR,
                demonstrative: process.env.REACT_APP_DEMONTRATIVE,
                expirationDate: generateExpirationDate(),
                identification: process.env.REACT_APP_IDENTIFICATION,
                instructions: process.env.REACT_APP_INSTRUCTIONS,
                softDescriptor: `GrupoMPT`,
                address: address.street
              }

              const link = "/course/BilletEnrollStudent"
              api.post(link, payload).then(res => {
                toast.success('Boleto gerado. Aguarde a confirmação')
                toggleLoading(false);
                toggleModal();
                refreshToken(dispatch);
                props.refresher();
                window.open(res.url, '_blank')
              }).catch(error => {
                toggleLoading(false);
                toast.error('Ops, algo deu errado durante a geração do boleto.')
              })
            }
          } else {
            return false;
          }
        });
    }
  }

  const generateExpirationDate = () => {
    let today = new Date()
    const expireDate = today.setDate(today.getDate() + process.env.REACT_APP_EXPIRATION_DAYS);
    const formattedDate = utils.dateObjToString(expireDate) // yyyy-mm-dd

    return formattedDate;
  }

  const generateBilletNumber = () => {
    const randomNumber = String(Math.random()).slice(2)
    const randomNumberOk = parseInt(randomNumber)
    
    return randomNumberOk.toString()
  }


  const getCourseDate = course => {
    switch (course.status) {
      case CourseStatusEnum.ACTIVE:
        return `${dayjs(course.enrollDays[course.enrollDays.length - 1].initialDate).format("DD/MM/YYYY")} - ${dayjs(course.enrollDays[course.enrollDays.length - 1].finishDate).format("DD/MM/YYYY")}`
      case CourseStatusEnum.INACTIVE:
        return `Curso inativo no momento`
      case CourseStatusEnum.ENROLL:
        return `${dayjs(course.enrollDays[course.enrollDays.length - 1].initialDate).format("DD/MM/YYYY")} - ${dayjs(course.enrollDays[course.enrollDays.length - 1].finishDate).format("DD/MM/YYYY")}`
      case CourseStatusEnum.SOON:
        return ``
      default:
        return `${course.descriptionDate}`
    }
  }

  const mountButtonOfActiveCourse = (course, userExist) => {
    if(userExist) return <StyledButtonLink to={`/course/${course._id}`}>Acessar</StyledButtonLink> // Matriculado
    else return <StyledButtonDisabled>Curso já ativo</StyledButtonDisabled> // Não matriculado
  }

  const mountCourseButton = (course, userExist) => {
    switch (course.status) {
      case CourseStatusEnum.ACTIVE:
        return mountButtonOfActiveCourse(course, userExist)
      case CourseStatusEnum.INACTIVE:
        return <StyledButtonDisabled>Encerrado</StyledButtonDisabled>
      case CourseStatusEnum.ENROLL:
        return <StyledButton onClick={() => toggleModal(course._id)}>Increver-se</StyledButton>
      case CourseStatusEnum.SOON:
        return <StyledButtonDisabled>Aguarde</StyledButtonDisabled>
      default:
        //#TODO: Texto aguarde
        return <StyledButtonDisabled>1º/03</StyledButtonDisabled>
    }
  }


  const ERROR_MESSAGES = {
    emptyCardNumber: 'O número do cartão não pode estar vazio.',
    invalidCardNumber: 'O número do cartão é inválido.',
    emptyExpiryDate: 'A data de expiração não pode estar vazia.',
    monthOutOfRange: 'O mês de expiração deve estar entre 01 e 12.',
    yearOutOfRange: 'O ano de expiração não pode estar no passado.',
    dateOutOfRange: 'A data de expiração não pode estar no passado.',
    invalidExpiryDate: 'A data de expiração é inválida.',
    emptyCVC: 'O código de segurança não pode estar vazio.',
    invalidCVC: 'O código de segurança é inválido.'
  }

  const {
    meta,
    wrapperProps,
    getCardImageProps,
    getCardNumberProps,
    getExpiryDateProps,
    getCVCProps
  } = usePaymentInputs({ errorMessages: ERROR_MESSAGES });

  const getCEP = (cep) => {
    toggleLoading(true)
    if (cep.length === 8) {
      Axios.get(`https://viacep.com.br/ws/${cep}/json/`).then(res => {
        const { data } = res

        setAddress({
          ...address,
          city: data.localidade,
          estate: data.uf,
          street: data.logradouro,
          zipCode: data.cep,
          district: data.uf,
          country: 'Brasil' // Medida provisória
        })
        toggleLoading(false)
      })
    }
  }
  const { REACT_APP_PROMOTIONCODE, REACT_APP_PROMOTIONDISCOUNT } = process.env

  return <CourseCardContainer>
    <CardBody className="text-center">
      <CardBodyClass>
        <CardTitle>{props.course.name}</CardTitle>
        <span style={{ margin: "10px 0px", marginTop: "auto", fontSize: 18 }}>{props.course.description}</span>
        {/* <span style={{ margin: "10px 0px" }}>{getCourseDate(props.course)}</span> */}
        {mountCourseButton(props.course, props.userExist)}
      </CardBodyClass>
    </CardBody>
    <Modal isOpen={modalVisibility} toggle={toggleModal} size="lg">
      <StyledModalBody>
        <BlockUi tag="div" blocking={loading} loader={<Loader active type="line-scale-party" color="#296ba9" />} >
          <FormContainer>
            <Col xs={12} md={7}>
              <CreditCardContainerTop>
                <div style={{ width: 100, height: 100, backgroundColor: "#296ba9", borderRadius: 5 }}><img alt="course-logo" className="img-fluid" src={courseIcon} /></div>
                <CreditCardContainer>
                  <strong style={{ fontSize: 24 }}>{props.course.name}</strong>
                  {promotionCode === REACT_APP_PROMOTIONCODE ?
                    < span style={{ fontSize: 18, fontWeight: 'normal' }}>{utils.formatBRL(decimal.sub(props.course.price, decimal.div(decimal.mul(props.course.price, REACT_APP_PROMOTIONDISCOUNT), 100)))}</span>
                    :
                    <span style={{ fontSize: 18, fontWeight: 'normal' }}>{utils.formatBRL(props.course.price)}</span>
                  }
                </CreditCardContainer>
              </CreditCardContainerTop>
              <CreditCardContainer>
                <CreditCardContainerLabel>Dados pessoais</CreditCardContainerLabel>
                <Input
                  name="name"
                  placeholder="Nome completo"
                  maxLength={70}
                  value={name}
                  onChange={event => setName(event.target.value)}
                  className="form-control"
                  style={{
                    border: errors.name ? '2px solid #c9444d' : '1px solid #ced4da'
                  }}
                />
                <ErrorSpan style={{ marginBottom: 10 }}>{errors.name}</ErrorSpan>
                <Input
                  name="document"
                  placeholder="CPF"
                  value={document}
                  maxLength={11}
                  onChange={event => {
                    const re = /^[0-9\b]+$/;
                    if (event.target.value === '' || re.test(event.target.value))
                      setDocument(event.target.value)
                  }}
                  className="form-control"
                  pattern="[0-9]+"
                  style={{
                    border: errors.document ? '2px solid #c9444d' : '1px solid #ced4da'
                  }}
                />
                <ErrorSpan>{errors.document}</ErrorSpan>
                <Input
                  name="promotionCode"
                  placeholder="Código de Desconto"
                  maxLength={10}
                  error={errors ? errors.promotionCode : ''}
                  value={promotionCode}
                  onChange={event => setPromotionCode(event.target.value)}
                  className="form-control"
                  style={{
                    border: errors.promotionCode ? '2px solid #c9444d' : '1px solid #ced4da', marginBottom: '2px'
                  }}
                />
              </CreditCardContainer>
              <CreditCardContainer>
                <CreditCardContainerLabel>Dados do pagamento</CreditCardContainerLabel>
                {/* <strong>Meio de pagamento</strong>
                <FormGroup check>
                  <Label check>
                    <Input type="radio" name="radio1" value="CC" onChange={() => setType("CC")} />
                    Cartão de crédito
                </Label>
                </FormGroup>
                <FormGroup check>
                  <Label check>
                    <Input type="radio" name="radio1" value="invoice" onChange={() => setType("invoice")} />{' '}
                    Boleto
                  </Label>
                </FormGroup> */}
                {type === "invoice" && <>
                  <Input
                    name="cep"
                    placeholder="CEP"
                    value={address.cep}
                    maxLength={8}
                    onChange={event => {
                      const re = /^[0-9\b]+$/;
                      if (event.target.value === '' || re.test(event.target.value))
                        setAddress({ ...address, cep: event.target.value })
                    }}
                    className="form-control"
                    pattern="[0-9]+"
                    onBlur={event => {
                      const re = /^[0-9\b]+$/;
                      if (re.test(event.target.value)) 
                        getCEP(event.target.value) 
                    }}
                    style={{
                      border: errors.cep ? '2px solid #c9444d' : '1px solid #ced4da',
                      marginBottom: 5
                    }}
                  />
                  <ErrorSpan>{errors.cep}</ErrorSpan>
                  <Input
                    name="street"
                    placeholder="Rua"
                    readOnly
                    value={address.street}
                    style={{ marginBottom: 5 }}
                  />
                  <Input
                    name="number"
                    placeholder="Número"
                    value={address.number}
                    onChange={event => {
                      const re = /^[0-9\b]+$/;
                      if (event.target.value === '' || re.test(event.target.value))
                        setAddress({ ...address, number: event.target.value })
                    }}
                    className="form-control"
                    pattern="[0-9]+"
                    style={{
                      border: errors.number ? '2px solid #c9444d' : '1px solid #ced4da',
                      marginBottom: 5
                    }}
                  />
                  <ErrorSpan>{errors.number}</ErrorSpan>
                  <Input
                    name="city"
                    placeholder="Cidade"
                    readOnly
                    value={address.city}
                    style={{ marginBottom: 5 }}
                  />
                  <Input
                    name="estate"
                    placeholder="Estado"
                    readOnly
                    value={address.estate}
                    style={{ marginBottom: 5 }}
                  />
                  <Input
                    name="complement"
                    placeholder="Complemento"
                    value={address.complement}
                    onChange={event => setAddress({ ...address, complement: event.target.value })}
                    className="form-control"
                    style={{
                      border: errors.complement ? '2px solid #c9444d' : '1px solid #ced4da'
                    }}
                  />
                </>}
                {type === "CC" && <>
                  <ErrorSpan>{errors.installments}</ErrorSpan>
                  <Input
                    type="select"
                    name="installments"
                    placeholder="Parcelas"
                    value={installments}
                    onChange={event => setInstallments(event.target.value)}
                    className="form-control"
                    style={{ marginBottom: 10, border: errors.installments ? '2px solid #c9444d' : '1px solid #ced4da' }}>
                    {priceWithInstallments}
                    {priceWithInstallments.map((price, index) => {
                      let text = `${settedInstallments[index]}x de ${utils.formatBRL(price)}`
                      if (settedInstallments[index] === 1) text += ` (Crédito à vista)`
                      return <option key={`price_${index}`} value={settedInstallments[index]}>{text}</option>
                    })}
                  </Input>
                  <PaymentInputsWrapper {...wrapperProps}>
                    <svg {...getCardImageProps({ images })} />
                    <input {...getCardNumberProps({ onChange: (event) => setCardNumber(event.target.value) })} placeholder="Nº do Cartão de Crédito" value={cardNumber} />
                    <input {...getExpiryDateProps({ onChange: (event) => setExpiryDate(event.target.value) })} placeholder="MM/AA" value={expiryDate} />
                    <input {...getCVCProps({ onChange: (event) => setCVC(event.target.value) })} value={cvc} />
                  </PaymentInputsWrapper>
                </>}
              </CreditCardContainer>
              <StyledFormButton onClick={payCourse}>Inscrever-se</StyledFormButton>
            </Col>
          </FormContainer>
        </BlockUi>
      </StyledModalBody>
    </Modal>
  </CourseCardContainer>;
}

export default CourseCard;
